/**
 * Mounts the Atlas form for the active config tab (see ConnectorConfigDialog).
 */

import React, { useState } from 'react';
import { FormRenderer } from '@atlas-forms/player-components-react';
import { decodeHtmlEntities, formSeedValues } from './formSeed';

export interface ConfigFormHostProps {
  schema: any;
  /** The user's latest edits to this form (formRendererValues). */
  edited: Record<string, any>;
  /** The saved starting values for this form (formRendererInitialValues). Entities are HTML-encoded. */
  saved: Record<string, any>;
  onValuesChange: (values: Record<string, any>) => void;
}

/**
 * The form starts from the user's edits if there are any, otherwise from the saved values, and reads
 * them once, at mount. The parent unmounts this host when the Configuration tab is left, and keys it by
 * form, so each return to the tab restores unsaved edits (BUG-08) and each form switch starts fresh.
 * Nothing re-seeds the form while the user types: later edits flow out through onValuesChange only.
 */
export const ConfigFormHost: React.FC<ConfigFormHostProps> = ({ schema, edited, saved, onValuesChange }) => {
  const [seed] = useState(() => formSeedValues(edited, decodeHtmlEntities(saved)));
  return (
    <FormRenderer
      schema={schema}
      mode="edit"
      initialValues={seed}
      onValuesChange={onValuesChange}
      nested={false}
      enableCsrfProtection={false}
      showValidationSummary={false}
    />
  );
};
